export default __webpack_public_path__ + "static/A-pe-e497e0830f00ac74b764b673c30b1303.svg";